export const paymentTypeSelector = (state: any) => state.paymentType;
